import { Box, Button, Stack, Typography } from '@mui/material';

import { cardSx, wf } from '../shell/tokens';

export function IntakeKickoffCard({ onScheduleClick }: { onScheduleClick?: () => void }) {
  return (
    <Box
      component="aside"
      aria-label="Implementation kickoff"
      sx={{ ...cardSx, padding: '22px 24px' }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing="18px"
        sx={{ alignItems: { sm: 'center' }, justifyContent: 'space-between' }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography component="h2" sx={{ fontSize: 15, fontWeight: 700 }}>
            Meet your implementation team
          </Typography>
          <Typography sx={{ fontSize: 13, color: wf.muted, lineHeight: 1.6, mt: '4px' }}>
            Choose a time for your kickoff. Scheduling a meeting does not change your setup
            progress.
          </Typography>
        </Box>
        <Button
          variant="outlined"
          href="https://calendly.com/d/d3zg-tpb-b84/implementation-kickoff"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onScheduleClick}
          sx={{ flexShrink: 0 }}
        >
          Schedule kickoff (new tab)
        </Button>
      </Stack>
    </Box>
  );
}
